import { render } from "./TipsByStatus.vue?vue&type=template&id=1aa005c4&scoped=true"
import script from "./TipsByStatus.vue?vue&type=script&lang=js"
export * from "./TipsByStatus.vue?vue&type=script&lang=js"

import "./TipsByStatus.vue?vue&type=style&index=0&id=1aa005c4&lang=scss&scoped=true"

import exportComponent from "/Users/cp/Code/betslip/BetslipPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa005c4"]])

export default __exports__